export default class Timer {
  /**
   * Starts or restarts a named timer for the given time
   * @param {String} name Timer name
   * @param {Number} time The time to wait before finishing
   */
  static async begin(name, time = 1000) {
    if (Timer.timers[name]) {
      return Timer.timers[name].reset();
    }
    const instance = new Timer(time);
    instance.start();
    Timer.timers[name] = instance;
    return instance;
  }

  constructor(timeout) {
    this.timeout = timeout;
    this.handle = null;
    this.promise = false;
  }

  start() {
    this.promise = new Promise((r) => {
      this.resolve = r;
    });
    this.handle = setTimeout(() => {
      this.resolve(true);
    }, this.timeout);
    return this.promise;
  }

  reset() {
    this.stop();
    return this.start();
  }

  stop() {
    this.resolve(false);
    clearTimeout(this.handle);
  }
}

Timer.timers = {};
